"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _ErrorApi = require("./../../../../utils/ErrorApi");

var _ErrorApi2 = _interopRequireDefault(_ErrorApi);

var _Fetch = require("./../../../../utils/Fetch");

var _Fetch2 = _interopRequireDefault(_Fetch);

var _ParamsFetch = require("./../../../../utils/ParamsFetch");

var _ParamsFetch2 = _interopRequireDefault(_ParamsFetch);

var _JsonFetch = require("./../../../../utils/JsonFetch");

var _JsonFetch2 = _interopRequireDefault(_JsonFetch);

var _generateUrl = require("./../../../../utils/generateUrl");

var _generateUrl2 = _interopRequireDefault(_generateUrl);

var _UpdateMethods = require("./../UpdateMethods");

var UpdateMethods = _interopRequireWildcard(_UpdateMethods);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Serviska pro práci s objekty. Generated from cz.marbes.api.objekt.v1.ObjektService.
 */
// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-01-07T17:41:11Z                      #

// ##############################################################

var ObjektApi = function () {
  function ObjektApi() {
    (0, _classCallCheck3.default)(this, ObjektApi);
  }

  (0, _createClass3.default)(ObjektApi, null, [{
    key: "findById",

    /**
     * Vrátí objekt podle id. U lokálních objektů vrátí všechny data. U externích poze informace z Eobj_objekt (id v KN, popis, ...).
     *
     * @param id 
     * @return objekt
     */
    value: function findById(id) {
      var uri = serverContextPath + ("/api/objekt/v1/objekty/" + id);
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Najde id objektu podle id z KN.
     *
     * @param idKn 
     * @param typObjekt 
     * @return 
     */

  }, {
    key: "findObjektIdByKnId",
    value: function findObjektIdByKnId(idKn, typObjekt) {
      var uri = serverContextPath + "/api/objekt/v1/objekty/objektyIdByKn";
      var headers = undefined;
      var params = { idKn: idKn, typObjekt: typObjekt };

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Vytvori objekt v lokální databázi.
     *
     * @param objektResult 
     * @return 
     */

  }, {
    key: "createObjektLocal",
    value: function createObjektLocal(objektResult) {
      var uri = serverContextPath + "/api/objekt/v1/objekty/local";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, UpdateMethods.updateAbstractObjekt_09F075v1(objektResult), headers));
    }

    /**
     * Funguje stejne jako {@link #createObjektLocal(AbstractObjekt)}. Poze se vybrane typy objektu (parcely) pokusi ztotoznit na XRN. Pokud se ztotozneni nepodari je vyhozena vyjimka.
     *
     * @param objektResult 
     * @return 
     */

  }, {
    key: "createObjektLocalZtotozneni",
    value: function createObjektLocalZtotozneni(objektResult) {
      var uri = serverContextPath + "/api/objekt/v1/objekty/localZtotozneni";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, UpdateMethods.updateAbstractObjekt_09F075v1(objektResult), headers));
    }

    /**
     * Vrátí objekty podle jejich id v lokálním systému. Data o objektech jsou získány z externích systémů, nebo lokálních pokud jsou uložena pouze v databázi. Pokud jsou požadována pouze lokální data použijte {@link #findByIdIn(Collection)}.
     *
     * @param idObjektList 
     * @return 
     */

  }, {
    key: "findObjektByIds",
    value: function findObjektByIds(idObjektList) {
      var uri = serverContextPath + "/api/objekt/v1/objekty/ids";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, idObjektList, headers));
    }

    /**
     * Najde id objektů podle id v ENO.
     *
     * @param enoIds 
     * @return id objektu / id v ENO
     */

  }, {
    key: "findObjektIdByEnoIds",
    value: function findObjektIdByEnoIds(enoIds) {
      var uri = serverContextPath + "/api/objekt/v1/objekty/objektyId/enoIds";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, enoIds, headers));
    }

    /**
     * Najde polohu objektu v KN.
     *
     * @param idObjektList id objektu v eobj.
     * @return 
     */

  }, {
    key: "getObjektGeometry",
    value: function getObjektGeometry(idObjektList) {
      var uri = serverContextPath + "/api/objekt/v1/objekt/poloha";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.put(uri, params, idObjektList, headers));
    }

    /**
     * Vytvoří záznam o objektu v lokální databázi, ale data jsou v externím systému.
     *
     * @param objektResult 
     * @return 
     */

  }, {
    key: "createObjekt",
    value: function createObjekt(objektResult) {
      var uri = serverContextPath + "/api/objekt/v1/objekty";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, UpdateMethods.updateObjektSearchResult_A9F268v1(objektResult), headers));
    }

    /**
     * Najde objekty dle předaných parametrů.
     *
     * @param query fulltextový dotaz
     * @param obec omezení hledání za kód obce
     * @param ku omezení hledání za kód katastrálního území
     * @param zaklTyp omezení hledání dle záklaního typu objektu
     * @param typ omezení hledání dle kódů typů objektů
     * @param zdroj omezení hledání na zdroj dat
     * @param max omezení počtu vrácených záznamů
     * @return nalezené objekty
     */

  }, {
    key: "findObjektFulltext",
    value: function findObjektFulltext(query, obec, ku, zaklTyp, typ, zdroj, max) {
      var uri = serverContextPath + "/api/objekt/v1/objekty";
      var headers = undefined;
      var params = { query: query, obec: obec, ku: ku, zaklTyp: zaklTyp, typ: typ, zdroj: zdroj, max: max };

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * smaže lokální údaje o objektu.
     *
     */

  }, {
    key: "deleteObjekt",
    value: function deleteObjekt() {
      var uri = serverContextPath + "/api/objekt/v1/objekty/{id}";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.delete(uri, params));
    }

    /**
     * Najde zaznam o objektech podle id z katastru.
     *
     * @param idKn 
     * @param typObjekt 
     * @return 
     */

  }, {
    key: "findObjektByKn",
    value: function findObjektByKn(idKn, typObjekt) {
      var uri = serverContextPath + "/api/objekt/v1/objekty/objektByKn";
      var headers = undefined;
      var params = { idKn: idKn, typObjekt: typObjekt };

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Načtení číselníku typ komunikace.
     *
     * @return 
     */

  }, {
    key: "getTypKomunikace",
    value: function getTypKomunikace() {
      var uri = serverContextPath + "/api/objekt/v1/objekty/typKomunikace";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Načte informace z externích systémů podle id v externím systému. Id AbstractObjekt je id v externim systemu.
     *
     * @param extIds 
     * @param zdroj 
     * @return 
     */

  }, {
    key: "findObjektInExtSystem",
    value: function findObjektInExtSystem(extIds, zdroj) {
      var uri = serverContextPath + ("/api/objekt/v1/objekty/extSystem/" + zdroj);
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, extIds, headers));
    }

    /**
     * Vrátí obsah číselníku typů objektů.
     *
     * @return typy objektů
     */

  }, {
    key: "getTypObjektu",
    value: function getTypObjektu() {
      var uri = serverContextPath + "/api/objekt/v1/objekty/typObjektu";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Načtení číselníku druhu povrchu.
     *
     * @return 
     */

  }, {
    key: "getDruhPovrchu",
    value: function getDruhPovrchu() {
      var uri = serverContextPath + "/api/objekt/v1/objekty/druhPovrchu";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Najde id objektů podle id v ext systemu.
     *
     * @param extIds 
     * @param zdroj 
     * @return id objektu / id v ext systemu
     */

  }, {
    key: "findObjektIdByExtIds",
    value: function findObjektIdByExtIds(extIds, zdroj) {
      var uri = serverContextPath + ("/api/objekt/v1/objekty/objektyId/extIds/" + zdroj);
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, extIds, headers));
    }

    /**
     * Aktualizuje lokalni objekt.
     *
     * @param objektInput 
     * @return 
     */

  }, {
    key: "updateObjektLocal",
    value: function updateObjektLocal(objektInput) {
      var uri = serverContextPath + "/api/objekt/v1/objekty/local";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.put(uri, params, UpdateMethods.updateAbstractObjekt_09F075v1(objektInput), headers));
    }

    /**
     * Načtení číselníku strana komunikace.
     *
     * @return 
     */

  }, {
    key: "getStranaKomunikace",
    value: function getStranaKomunikace() {
      var uri = serverContextPath + "/api/objekt/v1/objekty/stranaKomunikace";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }
  }]);
  return ObjektApi;
}();

exports.default = ObjektApi;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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